// extracted by mini-css-extract-plugin
export default {"Container":"Answer_Container__9RcCr","Progress":"Answer_Progress__Sy04O","Icon":"Answer_Icon__BviLY","Title":"Answer_Title__PIRuS","Stat":"Answer_Stat__hXeHt"};